<template>
  <div>
    <dx-data-grid
      ref="dataGrid"
      :columns="columns"
      :data-source="store"
      :remote-operations="remoteOperations"
      :allow-column-resizing="true"
      :show-borders="true"
      :show-row-lines="false"
      :show-column-lines="true"
      :row-alternation-enabled="true"
    >
      <dx-sorting mode="multiple"/>

      <dx-filter-row :visible="true"/>
      <dx-filter-panel :visible="true"/>

      <dx-paging :page-size="20"/>
      <dx-pager
        :allowed-page-sizes="[15, 20, 50]"
        :visible="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
      />
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid } from 'devextreme-vue';
import {
  DxFilterPanel,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxSorting,
} from 'devextreme-vue/data-grid';
import createBackendStore from '@/lib/create-backend-store';
import { buildColumns } from '@/lib/data-grid-columns';

export default {
  name: 'IncompleteLocaleGrid',
  components: {
    DxDataGrid,
    DxFilterRow,
    DxFilterPanel,
    DxPager,
    DxPaging,
    DxSorting,
  },
  props: {
    namespace: { type: String, default: 'default' },
  },
  data() {
    return {
      columns: [],
      store: null,
      remoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
    };
  },
  computed: {
    dataGrid() {
      return this.$refs.dataGrid.instance;
    },
  },
  watch: {
    namespace(value) {
      this.dataGrid.columnOption('namespace', 'filterValue', value);
    },
  },
  methods: {
    buildColumns,
    configureColumns() {
      return [
        ...this.buildColumns('locale', [
          {
            property: 'namespace',
            visible: false,
            filterOperations: ['='],
          },
          {
            property: 'key',
            sortOrder: 'asc',
          },
          {
            property: 'language',
            width: '10%',
            sortOrder: 'asc',
          },
        ]),
        {
          type: 'buttons',
          buttons: [{
            text: this.$t('common.add'),
            icon: 'add',
            onClick: event => this.$emit('click:showCreateLocaleDialog', event.row.data),
          }],
          width: 40,
        },
      ];
    },
    configureStore(columns) {
      return createBackendStore('/incomplete-locales', {
        keyProperty: null,
        fields: columns.map(c => c.dataField)
          .filter(f => !!f),
      });
    },
    refresh() {
      this.dataGrid.refresh();
    },
  },
  created() {
    this.columns = this.configureColumns();
    this.store = this.configureStore(this.columns);
  },
  mounted() {
    this.dataGrid.columnOption('namespace', 'filterValue', this.namespace);
  },
};
</script>

<style scoped>

</style>
